import { LearningProgressLearnerEditPage } from "@/features/learning-progress/pages/LearningProgressLearnerEdit";

export default LearningProgressLearnerEditPage;
